import React from 'react';

type HeadingType = { id: string; text: string; level: number };

export function useHeadings() {
  const [headings, setHeadings] = React.useState<HeadingType[]>([]);
  React.useEffect(() => {
    const elements = Array.from(document.querySelectorAll(("[id^='content_']")))
      .filter((element) => element.id)
      .map((element) => ({
        id: element.id,
        text: element.textContent ?? '',
        level: Number(element.tagName.substring(1)),
      }));
    setHeadings(elements);
  }, []);
  return headings;
}

export function useScrollSpy(paramsStr: string) {
  const [activeId, setActiveId] = React.useState<string>();
  const observer = React.useRef<IntersectionObserver>();
  React.useEffect(() => {
    const params = JSON.parse(paramsStr);
    const { headingIds, rootMargin } = params;
    const elements = headingIds.map((id: string) => document.getElementById(id));
    observer.current?.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry?.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    }, { rootMargin });
    elements.forEach((el: Element) => {
      if (el) {
        observer.current?.observe(el);
      }
    });
    return () => observer.current?.disconnect();
  }, [paramsStr]);
  return activeId;
}
